@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<div class="container" kb-layout="grid" [appEditorId]="editorIds?.playlistId">
  <div kb-grid-item-columns="8" class="active-video">
    @if ((userConsent.given$ | async) === false) {
      @if (activeVideo$ | async; as activeVideo) {
        <img
          class="youtube-thumbnail"
          [src]="getThumbnailUrl(activeVideo)"
          alt=""
          loading="lazy"
        >
      }
      <app-user-consent-dialog [consent]="userConsent">
        <ng-container slot="title" i18n="YouTube GDPR consent title@@5925881507551885808">Data transmission to YouTube</ng-container>
        <ng-container i18n="YouTube GDPR consent body@@6332247001604089884">
          This video is embedded on our website via YouTube.<br>
          Data is only transmitted to YouTube when you click on “Agree”.<br>
          Please refer to <a kb-link href="https://www.youtube.com/t/privacy" target="_blank">the privacy policy of YouTube</a> for more details.
        </ng-container>
      </app-user-consent-dialog>
    } @else {
      @if (activeVideo$ | async; as activeVideo) {
        <iframe
          [src]="getEmbedUrl(activeVideo.id) + '?modestbranding=1&autohide=1&showinfo=0&controls=1'| safe: 'resourceUrl'"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      }
    }
    @if (activeVideo$ | async; as activeVideo) {
      <div class="metadata">
        <h3 kb-heading>{{ activeVideo.title }}</h3>
        <p kb-paragraph>
          <kb-line-clamp lines="2">
            {{ activeVideo.description }}
          </kb-line-clamp>
        </p>
      </div>
    } @else {
      @if (errorMessage$ | async; as errorMessage) {
        <p kb-paragraph>{{ errorMessage }}</p>
      } @else {
        <kb-progress-indicator [visible]="true"></kb-progress-indicator>
      }
    }
  </div>
  <div kb-grid-item-columns="4" class="playlist" kb-layout="flex">
    @if (playlist$ | async; as playlist) {
      @for (video of playlist.videos; track video) {
        <button class="playlist-item" type="button" kb-layout="flex" (click)="setActive(video)" [class.active]="video.id === (activeVideo$ | async)?.id">
          <div class="thumbnail-container" kb-flex-item="half">
            <img
              [src]="getThumbnailUrl(video)"
              alt=""
              loading="lazy"
            >
            <kb-icon [icon]="iconPlay"></kb-icon>
          </div>
          <div kb-flex-item="half">
            {{ video.title }}
          </div>
        </button>
      }
    }
    @if (playlistId$ | async; as playlistId) {
      <a kb-button [href]="getPlaylistUrl(playlistId)" target="_blank">
        <ng-container i18n="YouTube playlist see more videos@@5989780066637297150">See all videos on YouTube</ng-container>
        <kb-icon [icon]="iconArrowsRight"></kb-icon>
      </a>
    }
  </div>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
